import React, { useEffect, useState } from 'react';
import { MessageBar, MessageBarBody, MessageBarTitle, Spinner } from '@fluentui/react-components';
import { useNavigate, useParams } from 'react-router-dom';
import { sharedDashboardsService } from '../api/sharedDashboardsService';
import './SharedDashboardPage.css';

const AcceptSharedDashboardPage: React.FC = () => {
  const { token = '' } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    sharedDashboardsService.accept(token)
      .then(({ dashboardId }) => {
        if (!cancelled) navigate(`/shared-dashboards/${dashboardId}`, { replace: true });
      })
      .catch(() => { if (!cancelled) setFailed(true); });
    return () => { cancelled = true; };
  }, [navigate, token]);

  return (
    <div className="shared-dashboard-state">
      {failed ? (
        <MessageBar intent="error">
          <MessageBarBody><MessageBarTitle>Dashboard unavailable</MessageBarTitle>The link is invalid, expired, or revoked.</MessageBarBody>
        </MessageBar>
      ) : <Spinner size="large" label="Adding shared dashboard" />}
    </div>
  );
};

export default AcceptSharedDashboardPage;